




import { defineComponent, inject, computed } from '@nuxtjs/composition-api';
import { Category, useCategories } from '~/features/categories';
import { ROOT_CATEGORY_ID } from '~/features/categorySlider';
import { useI18n } from '~/features/i18n';
import { CATEGORY_CONTEXT } from '~/utils/provides';

export default defineComponent({
  name: 'CategoryBreadcrumb',
  setup() {
    const category = inject(CATEGORY_CONTEXT) as Category;
    const { t } = useI18n();
    const { flatCategories } = useCategories();

    const categories = computed(() => {
      return category?.url
        ?.split('/')
        .map(item => flatCategories.value.find(category => category.url?.includes(`/${item}`)));
    });

    const items = computed(() => [
      {
        label: t('home'),
        path: '',
      },
      // { label: flatCategories.value[0]?.name, path: flatCategories.value[0]?.url_key },
      ...(categories.value
        ?.filter(category => category?.id?.toString() !== ROOT_CATEGORY_ID && category?.name)
        .map(category => {
          return {
            label: category?.name as string,
            path: `/${category?.url_key}` || '/',
          };
        }) || []),
    ]);

    return {
      items,
    };
  },
});
